import React from "react";

export const IconOption2 = () => {
  return (
    <svg
      width="14"
      height="20"
      viewBox="0 0 14 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.4247 3.9166L7.54834 0.523926V4.12698L10.3044 5.7176L13.4247 3.9166Z"
        fill="#F2F2F2"
      />
      <path
        d="M6.73651 4.12698V0.523926L0.86084 3.9166L3.98078 5.7176L6.73651 4.12698Z"
        fill="#F2F2F2"
      />
      <path
        d="M3.57547 6.42052L0.455566 4.61914V15.4758L3.57547 13.6741V6.42052Z"
        fill="#F2F2F2"
      />
      <path
        d="M0.86084 16.1787L6.73651 19.5713V15.9683L3.98112 14.377L0.86084 16.1787Z"
        fill="#F2F2F2"
      />
      <path
        d="M7.54834 15.9686V19.5713L13.4244 16.1787L10.3041 14.377L7.54834 15.9686Z"
        fill="#F2F2F2"
      />
      <path
        d="M10.71 6.42089V13.6744L13.8302 15.4761V4.61914L10.71 6.42089Z"
        fill="#F2F2F2"
      />
      <path
        d="M9.89821 6.42059L7.14245 4.82959L4.38672 6.42092V13.6745L7.14245 15.2658L9.89821 13.6745V6.42059ZM5.33266 10.1971V7.51385L7.39725 6.27524L5.33266 10.1971Z"
        fill="#F2F2F2"
      />
    </svg>
  );
};
